import { format } from 'date-fns';
import { fromZonedTime } from 'date-fns-tz';

export const DATE_FORMAT = 'yyyy-MM-dd';
export const DATE_DISPLAY_FORMAT = 'dd/MM/yyyy';
export const ISO_DATE_TIME_FORMAT = "yyyy-MM-dd'T'HH:mm:ssXXX";

const toDateString = (date: string | Date): string =>
  date instanceof Date ? format(date, DATE_FORMAT) : date;

export const toStartOfDayUTC = (date: string | Date, timezone: string): string =>
  fromZonedTime(`${toDateString(date)}T00:00:00`, timezone).toISOString();

export const toEndOfDayUTC = (date: string | Date, timezone: string): string =>
  fromZonedTime(`${toDateString(date)}T23:59:59.999`, timezone).toISOString();
